/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Button from 'ui/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import EntitySummary from './EntitySummary';

const ConfirmationCard = ({
  entityType,
  entityData,
  summaryFields,
  isCreating,
  onMakeChanges,
  onConfirm,
  chatT,
  supportsImageUpload = false
}) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const isArray = Array.isArray(entityData);
  const entities = isArray ? entityData : [entityData];

  const translatedEntityType = chatT(`aiChat:entities:${entityType}`);
  const displayEntityType = (entityType === 'ticket' && isArray && entities.length > 1)
    ? `${entities.length} ${chatT('aiChat:entities:tickets')}`
    : translatedEntityType;

  const handleImageSelect = (file) => {
    setSelectedImage(file);
  };

  const handleConfirm = () => {
    onConfirm(entityData, selectedImage);
  };

  return (
    <div className="ai-chat-confirmation-card">
      <div className="confirmation-header">
        <CheckCircleIcon className="confirmation-icon" />
        <span className="confirmation-title">{chatT('aiChat:confirmation:readyToCreate', { entityType: displayEntityType })}</span>
      </div>

      <div className="confirmation-entities">
        {entities.map((data, index) => (
          <div key={index} className={`confirmation-entity-wrapper`}>
            <EntitySummary
              entityData={data}
              summaryFields={summaryFields}
              supportsImageUpload={supportsImageUpload}
              selectedImage={selectedImage}
              onImageSelect={handleImageSelect}
              chatT={chatT}
              disabled={isCreating}
            />
          </div>
        ))}
      </div>

      <div className="confirmation-actions">
        <Button
          secondary
          fullwidth
          onClick={onMakeChanges}
          disabled={isCreating}
        >
          {chatT('aiChat:buttons:change')}
        </Button>
        <Button
          highlighted
          fullwidth
          onClick={handleConfirm}
          loading={isCreating}
        >
          {isArray && entities.length > 1 ? chatT('aiChat:buttons:createAll') : chatT('aiChat:buttons:create')}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationCard;

